module.exports = __webpack_public_path__ + "static/img/Cladding_Honey_Slatted.648469e.jpg";